<template>
  <div id="mine">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left">
        <!-- <van-icon name="arrow-left" size="20" /> -->
      </div>

      <div class="center">
        <img src="@/assets/logo.png" width="21" height="25" style="margin-top:6px" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>
      </div>
      <div class="right" @click="toHref()">
        <van-icon name="wap-home" size="21" />
      </div>
    </div>
    <div>
      <img src="@/assets/banner1.png" class="top-img" />
    </div>
    <div class="avatar">
      <img src="@/assets/avatar.png" width="60" height="60" />
      <van-loading type="spinner" v-show="showL" />
      <div>{{info.username}}</div>
    </div>
    <div class="info-list">
      <ul>
        <li @click="toUrl('/applyList')">
          <img src="@/assets/icon-summer.png" width="22" height="22" />
          <span class="vt-md">申请记录</span>
        </li>
        <li @click="tologinOut()">
          <img src="@/assets/icon-exit.png" width="22" height="22" />
          <span class="vt-md">退出</span>
        </li>
      </ul>
    </div>
    <van-dialog v-model="show" title="提示" show-cancel-button :beforeClose="beforeClose">
      <div style="margin:1.5rem 0">确定要退出登录吗？</div>
    </van-dialog>
  </div>
</template>
<script>
import { Icon, Toast, Loading, Dialog } from "vant";
import { loginOut, getUser, tokenStatus } from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [Loading.name]: Loading,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      token: "",
      info: [],
      showL: true,
      show: false,
    };
  },
  mounted() {
    var token = localStorage.getItem("tokenC");
    if (token) {
      this.token = token;
      this.getTokenS();
    } else {
      this.$router.push("/login");
    }
  },
  methods: {
    toUrl(u) {
      this.$router.push(u);
    },
     // 跳转首页
    toHref(){
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
    getUserInfo() {
      getUser({ token: this.token }).then((res) => {
        if (res.status == 1) {
          this.info = res.data;
          this.showL = false;
        } else {
          Toast(res.message);
        }
      });
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        loginOut({ token: this.token }).then((res) => {
          localStorage.removeItem("tokenC");
          if (res.status == 1) {
          Toast(res.message);
            this.$router.push("/login");
          }
        });
      } else {
        done();
      }
    },
    tologinOut() {
      this.show = true
    },
    getTokenS() {
      tokenStatus({ token: this.token }).then((res) => {
        if (res.status == 1) {
          this.getUserInfo();
        } else {
          this.$router.push("/login");
        }
      });
    },
  },
};
</script>
<style scoped>
.top-img {
  width: 100%;
  margin-top: 2.5rem;
}
.avatar {
  color: #423f3f;
  width: 60px;
  height: 60px;
  position: absolute;
  left: 50%;
  top: 5.5rem;
  /* margin-top: -200px; */
  margin-left: -30px;
}
.info-list {
  margin-top: 10px;
  padding: 0 10px;
  text-align: left;
}
.info-list li {
  position: relative;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
}
.info-list li span {
  margin-left: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/page/mine.vue